import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/')({
  beforeLoad: () => { throw redirect({ to: '/sales/dashboard' }); },
  component: () => null,
});
